var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFollowers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C6C6C6;}\n\t.st1{fill:#003D90;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.3,39.5c-1.3,0.1-2.5,0.2-3.8,0.3c-2.9,0.2-5.8,0.2-8.8,0c-3.5-0.2-6.9-0.6-10.3-1.4 c-0.2-0.1-0.5-0.1-0.7-0.2c-0.9-0.4-1.1-0.7-1-1.7c0.3-2.1,0.8-4.2,2-6c0.6-1,1.4-1.7,2.5-2.2c2.2-1.1,4.5-1.9,6.6-3.1 c0.4-0.2,1.1-0.4,1.2-0.8c0.2-0.3-0.5-0.7-0.7-1.1c-0.6-1.5-1.4-2.9-2.3-4.3c-0.6-1-0.8-2.2-0.6-3.4c0.1-0.3,0.2-0.6,0.5-0.7 c0.2-0.1,0.1-0.2,0.1-0.4c0-1.2,0-2.3,0.1-3.5c0.3-2.8,2.3-4.9,5.1-5.4c1.7-0.3,3.4-0.2,5.1,0.4c2.3,0.9,3.4,2.7,3.6,5.1 c0.1,1.1,0.1,2.2,0.1,3.3c0,0.2,0,0.4,0.3,0.4c0.3,0.1,0.3,0.4,0.4,0.7c0.3,1.7-0.3,3.2-1.3,4.5c-0.4,0.6-0.8,1.2-1,1.9 c-0.2,0.8-0.7,1.5-1.2,2.1c-0.2,0.2-0.2,0.3,0.1,0.4c0.9,0.5,1.9,1,2.9,1.5c0.2,0.1,0.3,0.2,0.1,0.4c-2.7,3.9-2.2,9.2,0.7,12.9 C26.2,39.4,26.3,39.4,26.3,39.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,32.4c0-5.5,4.4-9.9,9.9-9.9s9.9,4.4,9.9,9.9s-4.4,9.9-9.9,9.9C29.4,42.3,25,37.8,25,32.4z M40.3,34.7 c0.4,0,0.5-0.2,0.5-0.5c0-1.8,0-1.7,0-3.5c0-0.4-0.2-0.5-0.6-0.5c-1.5,0-3,0-4.5,0c-0.4,0-0.5-0.1-0.5-0.5c0-0.6,0-2.2,0-2.7 c0-0.2,0-0.4-0.2-0.5s-0.3,0-0.5,0.2c-1.8,1.8-4.6,3.6-6.4,5.4c-0.3,0.3-0.3,0.5,0,0.7c1.8,1.8,4.6,3.6,6.4,5.4 c0.1,0.1,0.3,0.3,0.5,0.2s0.2-0.3,0.2-0.5c0-0.6,0-2.2,0-2.8c0-0.4,0.1-0.4,0.4-0.4c0.8,0,1.5,0,2.3,0 C38.7,34.7,39.5,34.7,40.3,34.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowers);
export default __webpack_public_path__ + "static/media/followers.576fd670741c4a731d8dfca3e63e2d58.svg";
export { ForwardRef as ReactComponent };